var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"InsightMatrixPreview"},[_c('lm-logo',{directives:[{name:"show",rawName:"v-show",value:(_vm.resizing),expression:"resizing"}]}),_c('svg',{attrs:{"id":"IMatrix","width":_vm.width,"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }